var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconContact = function SvgIconContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-351.592 -450.592) translate(351.592 450.592)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#008060",
    d: "M13.524 14.684a1.161 1.161 0 0 0 1.159-1.159v-2.7a1.161 1.161 0 0 0-1.159-1.165 8.412 8.412 0 0 1-2.643-.423 1.177 1.177 0 0 0-1.181.281l-1.108 1.113a11.325 11.325 0 0 1-4.549-4.547l1.1-1.11a1.125 1.125 0 0 0 .3-1.177 8.4 8.4 0 0 1-.421-2.638A1.161 1.161 0 0 0 3.864 0h-2.7A1.161 1.161 0 0 0 0 1.159a13.54 13.54 0 0 0 13.524 13.525zM1.159.773h2.7a.387.387 0 0 1 .386.386 9.15 9.15 0 0 0 .459 2.875.366.366 0 0 1-.1.384L3.1 5.937a12.514 12.514 0 0 0 5.64 5.639l1.506-1.506a.4.4 0 0 1 .4-.1 9.159 9.159 0 0 0 2.881.46.387.387 0 0 1 .386.386v2.7a.387.387 0 0 1-.386.386A12.766 12.766 0 0 1 .773 1.159a.387.387 0 0 1 .386-.386z",
    transform: "translate(-351.592 -450.592) translate(356.637 455.637)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-contact.8269c706.svg";
export { ForwardRef as ReactComponent };